// Routing module for the upload module. Includes "new" and "list" routes.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HouseholdsComponent } from './views/households/households.component';
import { OrganizationsComponent } from './views/organizations/organizations.component';
import { MyAccountComponent } from './views/my-account/my-account.component';
import { UserDetailComponent } from './views/user-detail/user-detail.component';
import { SystemAdminComponent } from './views/system-admin/system-admin.component';
import { RoleGuard } from '../shared/guards/role.guard';
import { UserRole } from '../shared/services/user-role/user-role.service';

const routes: Routes = [
  {
    path: 'households',
    component: HouseholdsComponent,
    canActivate: [RoleGuard],
    data: { roles: [UserRole.SUPER_ADMIN, UserRole.SUPERVISOR, UserRole.MANAGER] }
  },{
    path: 'admin',
    component: SystemAdminComponent,
    canActivate: [RoleGuard],
    data: { roles: [UserRole.SUPER_ADMIN, UserRole.SUPERVISOR] }
  },{
    path: 'organizations',
    redirectTo: 'admin',
    pathMatch: 'full'
  },{
    path: 'application',
    redirectTo: 'admin',
    pathMatch: 'full'
  },{
    path: 'application/user/:id',
    component: UserDetailComponent,
    canActivate: [RoleGuard],
    data: { roles: [UserRole.SUPER_ADMIN, UserRole.SUPERVISOR, UserRole.MANAGER] }
  },{
    path: 'household/user/:id',
    component: UserDetailComponent,
    canActivate: [RoleGuard],
    data: { roles: [UserRole.SUPER_ADMIN, UserRole.SUPERVISOR, UserRole.MANAGER] }
  },{
    path: 'me',
    component: MyAccountComponent
  },{
    path: '**',
    redirectTo: 'households'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule {}
